import WasteManagementDashboardLayout from "../../Controller/LayoutController/WasteManagementDashboardLayout";
import AgriDashboardLayout from "../../Screens/AgriDashboardLayout/AgriDashboardLayout";
import GoogleMaps from "../../Screens/WasteManagement/GoogleMaps";
import BinOverview from "../../Screens/WaasteManagement/BinOverView/BinOverView";
import WasteCollectionType from "../../Screens/WaasteManagement/WasteCollectionType/WasteCollectionType";
import BinOverviewReport from "../../Screens/ReportSummary/BinOverviewReport";
import WasteOverviewReport from "../../Screens/ReportSummary/WasteOverviewReport";
import WasteReport from "../../Screens/ReportSummary/WasteOverviewReport";
import WasteManagementReportLayout from "../../Controller/LayoutController/WasteManagementReportLayout";
import ChatLayout from "../../Controller/LayoutController/ChatDashBoardLayout";
import ChatUIDashboard from "../../Assistance/ChatGptPrompt";
import FeedBackScreen from "../../Assistance/ChatGptFeedbackPrompt";
import SensorScreen from "../../Assistance/ChatGptSensorPrompt";
import DLCDashboard from "../../Screens/WaasteManagement/DLC/DLC";
import DLCReport from "../../Screens/ReportSummary/DLCReport";
import InfrastructureDasboard from "../../Controller/LayoutController/InfrastructureDasboard";
import AgricultureDashboard from "../../Controller/LayoutController/AgricultureDashboard";
import InsightsOverview from "../../Screens/Insights/InsightsOverview";
import RetailDashboardLayout from "../../Controller/LayoutController/RetailDashboardLayout";
import BinComponent from "../../Screens/CTM/Bin";

export default {
  WasteManagementDashboardLayout,
  AgriDashboardLayout,
  GoogleMaps,
  BinComponent,
  BinOverview,
  WasteCollectionType,
  BinOverviewReport,
  WasteOverviewReport,
  WasteReport,
  WasteManagementReportLayout,
  DLCDashboard,
  DLCReport,
  InfrastructureDasboard,
  AgricultureDashboard,
  InsightsOverview,
  RetailDashboardLayout,
  ChatUIDashboard,
  ChatLayout,
  FeedBackScreen,
  SensorScreen,
};
